module.exports = __webpack_public_path__ + "img/light_offline.3f369873.png";